/* eslint-disable linebreak-style */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable import/extensions */

import React from 'react';

import Button from '../elements/Button';

export default function BrandIcon() {
  return (
    <Button
      className=""
      type="link"
      href="/"
    >
      <p className="text-theme-white text-4xl font-medium ">
        Galactic
        <span className="text-theme-purple">Automation</span>
      </p>
    </Button>
  );
}
